export default "__VITE_ASSET__BZhS$zWZ__"